import React from 'react';

export const MatxLayouts = { layout1: React.lazy(() => import('./layout-1/Layout1')) };
